import { InputControl } from '@/components/controls/input-control';
import { cn } from '@/lib/utils';
import { useFormContext } from 'react-hook-form';

export const SuffixInput = ({
  name,
  label,
  suffix,
  className,
  ...props
}: any) => {
  const form = useFormContext();

  return (
    <div className={cn('relative', className)}>
      <InputControl
        control={form.control}
        name={name}
        label={label}
        {...props}
      />
      <span className="absolute right-3 bottom-[10px] text-gray-400 text-sm pointer-events-none">
        {suffix}
      </span>
    </div>
  );
};
